import React, { useState, useEffect } from 'react';
import { api, downloadCSV, Badge, Pagination, paginate, SearchBox, searchFilter } from './shared';

const TransactionsTab = ({ onError, hideReverted = false }) => {
  const [rawData, setRawData] = useState(null);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const fetch = async () => { setLoading(true); try { const r = await api('transactions'); setRawData(r.data.data); setPage(1); } catch(e) { onError(e.message); } finally { setLoading(false); } };
  useEffect(() => { fetch(); }, []); // eslint-disable-line

  // กรอง reverted ออก ถ้า hideReverted=true
  const data = rawData ? (hideReverted ? rawData.filter(t => t.status !== 'reverted') : rawData) : null;
  const summary = data ? {
    total: data.length,
    success: data.filter(d => d.status === 'success').length,
    pending: data.filter(d => d.status === 'pending').length,
    reverted: data.filter(d => d.status === 'reverted').length,
    totalSale: data.reduce((s, d) => s + Number(d.sale || 0), 0),
  } : null;

  const byStatus = data ? (filter === 'all' ? data : data.filter(t => t.status === filter)) : [];
  const filtered = searchFilter(byStatus, search, ['cusId', 'receiptNo', 'partner', 'store', 'displayName']);

  return (
    <div className="bts-admin__section">
      <div className="bts-admin__topbar">
        <div className="bts-admin__page-title">💰 Transaction</div>
        <div className="bts-admin__actions">
          <button className="bts-admin__btn bts-admin__btn--dark" onClick={fetch} disabled={loading}>{loading ? 'โหลด...' : 'รีเฟรช'}</button>
          {data && <button className="bts-admin__btn bts-admin__btn--green bts-admin__btn--sm" onClick={() => downloadCSV(
            ['วันที่','CLM CusId','Partner','Store','Sale','Status','ชื่อ'],
            filtered.map(t => [new Date(t.date).toLocaleString('th-TH'),t.cusId,t.partner,t.store,t.sale,t.statusLabel,t.displayName||'']),
            'bts_transactions.csv'
          )}>Export CSV</button>}
        </div>
      </div>
      {loading && <p>กำลังโหลด...</p>}
      {summary && (<>
        <div className="bts-admin__cards">
          <div className={`bts-admin__card ${filter==='all'?'bts-admin__card--active':''}`} style={{ borderColor:'#333' }} onClick={() => { setFilter('all'); setPage(1); }}><div className="bts-admin__card-value" style={{ color:'#333' }}>{summary.total}</div><div className="bts-admin__card-label">ทั้งหมด</div></div>
          <div className={`bts-admin__card ${filter==='success'?'bts-admin__card--active':''}`} style={{ borderColor:'#10C851' }} onClick={() => { setFilter('success'); setPage(1); }}><div className="bts-admin__card-value" style={{ color:'#10C851' }}>{summary.success}</div><div className="bts-admin__card-label">สำเร็จ</div></div>
          <div className={`bts-admin__card ${filter==='pending'?'bts-admin__card--active':''}`} style={{ borderColor:'#FF8A00' }} onClick={() => { setFilter('pending'); setPage(1); }}><div className="bts-admin__card-value" style={{ color:'#FF8A00' }}>{summary.pending}</div><div className="bts-admin__card-label">รอคิว</div></div>
          {!hideReverted && <div className={`bts-admin__card ${filter==='reverted'?'bts-admin__card--active':''}`} style={{ borderColor:'#999' }} onClick={() => { setFilter('reverted'); setPage(1); }}><div className="bts-admin__card-value" style={{ color:'#999' }}>{summary.reverted}</div><div className="bts-admin__card-label">ยกเลิก</div></div>}
        </div>
        <div className="bts-admin__case-box">
          <div className="bts-admin__case-title">สรุป</div>
          <div className="bts-admin__case-row"><span>💰 ยอดขายรวม</span><span className="bts-admin__case-count">฿{Number(summary.totalSale||0).toLocaleString()}</span></div>
          <div className="bts-admin__case-row" onClick={() => { setFilter('success'); setPage(1); }}><span>✅ บิลสำเร็จ</span><span className="bts-admin__case-count">{summary.success} บิล</span></div>
          <div className="bts-admin__case-row" onClick={() => { setFilter('pending'); setPage(1); }}><span>🕐 บิลรอคิว</span><span className="bts-admin__case-count">{summary.pending} บิล</span></div>
          {!hideReverted && <div className="bts-admin__case-row" onClick={() => { setFilter('reverted'); setPage(1); }}><span>🚫 ยกเลิกแล้ว</span><span className="bts-admin__case-count">{summary.reverted} บิล</span></div>}
        </div>
      </>)}
      {data && (<>
        <div className="bts-admin__filter-info"><span>แสดง {filtered.length} รายการ | ยอดรวม ฿{filtered.reduce((s,t)=>s+Number(t.sale||0),0).toLocaleString()}</span><SearchBox value={search} onChange={v => { setSearch(v); setPage(1); }} /></div>
        <div className="bts-admin__table-wrap">
          <table className="bts-admin__table">
            <thead><tr><th>สถานะ</th><th>วันที่</th><th>CLM CusId</th><th>เลขบิล</th><th>Partner</th><th>Store</th><th>Sale</th><th>ชื่อ</th></tr></thead>
            <tbody>{paginate(filtered, page).map((t, i) => (
              <tr key={i} className={t.status==='success'?'bts-admin__row--ok':t.status==='reverted'?'':'bts-admin__row--warn'}>
                <td>{t.status==='success'?<Badge color="green">{t.statusLabel}</Badge>:t.status==='reverted'?<Badge color="gray">{t.statusLabel}</Badge>:<Badge color="orange">{t.statusLabel}</Badge>}</td>
                <td>{new Date(t.date).toLocaleString('th-TH')}</td>
                <td>{t.cusId}</td><td>{t.receiptNo||'-'}</td><td>{t.partner}</td><td>{t.store}</td>
                <td>฿{Number(t.sale||0).toLocaleString()}</td>
                <td>{t.displayName||'-'}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
        <Pagination total={filtered.length} page={page} setPage={setPage} />
      </>)}
    </div>
  );
};

export default TransactionsTab;
